
// Subir archivo
export const uploadFile = async (file,bucket_name) => {
  const response = await fetch(`${process.env.REACT_APP_MINIOURL}/${bucket_name}/${file.name}`, {
    method: 'PUT',
    body: file,
    headers: {
      'Content-Type': file.type,
      'x-amz-acl': 'public-read', // Ajusta según tus permisos
    },
  });
  return response.ok;
};

export const listFiles = async (bucketUrl) => {
  const response = await fetch(`${bucketUrl}?list-type=2`);
  const xml = await response.text();
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(xml, 'application/xml');
  const items = Array.from(xmlDoc.getElementsByTagName('Contents')).map(item => {
    return item.getElementsByTagName('Key')[0].textContent;
  });
  return items;
};


// Eliminar archivo
export const deleteFile = async (fileName,bucket_name) => {
  const response = await fetch(`${process.env.REACT_APP_MINIOURL}/${bucket_name}/${fileName}`, {
    method: 'DELETE',
  });
  return response.ok;
};
